import { z } from 'zod';
import { freeze } from '@reduxjs/toolkit';
import { iconList } from '../../../../../components/Icon/iconList';
import {
  DESCRIPTION_MAX_LENGTH,
  TILE_TITLE_MAX_LENGTH,
} from '../../../../../config/constants';

export const upsertTileSchema = z.object({
  title: z.string().min(1).max(TILE_TITLE_MAX_LENGTH),
  description: z.string().min(1).max(DESCRIPTION_MAX_LENGTH),
  url: z
    .string()
    .refine(
      (value) =>
        /^(https?):\/\/(?=.*\.[a-z]{2,})[^\s$.?#].[^\s]*$/i.test(value),
      {
        message: 'Please enter a valid URL',
      },
    ),
  // allow only icon from our icon list
  icon: z.custom<keyof typeof iconList>((v) =>
    Object.keys(iconList).includes(v as string),
  ),
});

export type IUpsertTileState = z.infer<typeof upsertTileSchema>;

export const defaultUpsertTileState = freeze<IUpsertTileState>(
  {
    title: '',
    description: '',
    url: '',
    icon: 'chart-line',
  },
  true,
);
